import { secureApiDelete } from '../secureHttp';

export type BlockageDeleteInput = {
  date: string; // Format: YYYY-MM-DD
  start_time: string; // Format: HH:MM (24-hour format)
  end_time: string; // Format: HH:MM (24-hour format)
  /**
   * IDs únicos de los blockage slots a eliminar (devueltos por createBlockage / el fetch
   * de disponibilidad). Se envían además de date/start_time/end_time para que, cuando el
   * backend los soporte, el borrado identifique el registro exacto en vez de depender
   * únicamente del rango de fecha/horario — dos bloqueos con la misma fecha/horario/motivo
   * no son distinguibles sólo por esos campos.
   */
  ids?: string[];
};

export type BlockageDeleteResponse = {
  message?: string;
  deleted_count?: number;
};

/**
 * Delete blockage slots for a psychologist's calendar
 * This will delete all blockage slots within the specified date and time range
 *
 * @param data - Blockage deletion input (dates/times are in UTC)
 * @returns Response with deletion confirmation
 */
export async function deleteBlockage(data: BlockageDeleteInput): Promise<BlockageDeleteResponse> {
  return await secureApiDelete<BlockageDeleteResponse, BlockageDeleteInput>(
    `/v1/psi-platform/psychologist/calendar/blockages`,
    data,
    {
      showSuccessToast: false, // No mostrar toast automático, se muestra desde WeeklyPsychologistCalendar
      errorMessage: 'Error al desbloquear horario',
    }
  );
}
